export default "__VITE_ASSET__97iNl_Mv__"